import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import LogoLight from "..//../../../assets/images/footer/logo.png";
import contactIcon from "../../../../assets/images/footer/contact.png";
import addressIcon from "../../../../assets/images/footer/address.png";
import { useNavigate } from "react-router-dom";
import FooterLinks from "UI/footer-common-links/footerModal/footer-links";
import SocialIconsLinks from "UI/footer-common-links/social-icons";
import "./signup-footer.scss";

function SignupFooter() {
  const navigate = useNavigate();

  return (
    <>
      <Grid container className="SignUpFooter">
        <Grid item md={4} xs={12} className="divOne">
          <Box className="ppcn-img-box" onClick={() => navigate("/authentication/signin")}>
            {" "}
            <img src={LogoLight} alt="logo" />
          </Box>
          <Grid item md={9} sm={6} xs={12}>
            <p className="fs-14 ">
              DriverTok is a company registered in England and Wales with
              registered company number 12125945.
            </p>
          </Grid>
          <Grid item className="link">
            <SocialIconsLinks />
          </Grid>
        </Grid>

        <Grid item md={4} xs={12} sm={8} className="divTwo">
          <Grid item className="divTwo-heading">
            <img src={addressIcon} alt="icon" /> <span className="heading fs-18 text-white fw-500 ">Address</span>
            <Grid item md={1} className="responsive">
              <p
                style={{
                  borderBottom: "2px solid white",
                  padding: "0",
                  textAlign: "center",
                }}
              ></p>
            </Grid>
          </Grid>
          <Grid item lg={7} md={12} sm={12} xs={12}>
            <p className="fs-14">
              Office 77, Spaces Heathrow Airport, 4 Roundwood Avenue, Stockley Park, Uxbridge, UB11
              1AF United Kingdom
            </p>
          </Grid>
        </Grid>

        <Grid item md={4} xs={12} className="divThree">
          <Grid item className="divThree-heading">
            <img src={contactIcon} alt="icon" /> <span className="heading fs-18 text-white fw-500">Contact</span>
            <Grid item md={1} className="responsive">
              <p style={{ borderBottom: "2px solid white", padding: "0" }}></p>
            </Grid>
          </Grid>
          <p>(+44) - 750028 - 7504</p>
          <p>info@drivertok.co.uk</p>
        </Grid>

        <Grid container className="lowerFooter text-white" justifyContent="space-between" alignItems="center">
          <Grid item md={6} xs={12} sm={12}>
            <p className="copyright">
              Copyrights © 2022 All Rights Reserved by{" "}
              <span className="primary-color">DriverTok</span>
            </p>
          </Grid>
          <Grid item md={6} xs={12} sm={12} className="footerEnd">
            <FooterLinks footerStyle='' />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default SignupFooter;
